import React from 'react';
import { Link } from 'react-router';
import { Dialog, label } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemRole} from './datatable/list';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Danhmuc, DuLieuHeThong } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {CheckPermission} from 'modules/login/CheckPermission';
import Search from './Search.jsx';
import {DropDown, Input, TextArea, DropDownTreeMultipleSelect} from 'components/tt-forms/common';
import {MasterLayout} from 'layout';
import { ShowIf } from 'components/utils';
class Role extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      dataRole: [],
      roleSelected: [],
      DataLoaiVaiTro: [],
      dataOptions: [],
      dataSelected: [],
      donViCon: false,
      LoaiVaiTro: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      isValid: true,
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa:'',
      search: false,
      moTa: '',
      phoPhong: false
    };
  }

  componentDidMount() {
    this.getListData();
    this.getListRole();
    this.getListVaiTro();
    this.getListDV();
  }

  onChange(name, e) {
    if (name === 'DonVi') {
      this.setState({
        dataSelected: e
      });
    } else if (name === 'donViCon') {
      this.setState({donViCon: !this.state.donViCon});
    } else {
      this.setState({[name]: e.target.value});
    }
  }

  handleSearch() {
    this.setState({
      search: true
    });
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    }
    if(this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    Danhmuc.actions.getVaiTro.request(null, params).then(res => {
      if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.vaiTroes,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  getListRole() {
    this.props.danhMuc.getQuyen().then(res => {
      if (res.data) {
        this.setState({
          dataRole: res.data
        });
      } else {
        this.setState({
          dataRole: []
        });
      }
    });
  }

  getListVaiTro(){
    this.props.danhMuc.getListLoaiVaiTro({page: this.state.pageData.number, size: this.state.pageData.size}).then(res => {
      if (res.data) {
        this.setState({
          DataLoaiVaiTro: res.data,
          LoaiVaiTro: res.data[0].giaTri
        });
      }
    });
  }

  getListVaiTrotheoDV(){
    this.props.danhMuc.getListVaiTrotheoDV({page: this.state.pageData.number, size: this.state.pageData.size}).then(res => {
      if (res && res.data) {
        this.setState({
          DataLoaiVaiTro: res.data,
          LoaiVaiTro: res.data[0].giaTri
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  createCategory() {
    if(this.validateSubmitForm()){
      let params = {
        phoPhong: this.state.phoPhong,
        ten: this.state.ten.trim(),
        loaiVaiTro: this.state.LoaiVaiTro,
        moTa: this.state.moTa,
        quyen: this.state.roleSelected.join(',')
      };
      if (this.state.dataSelected && this.state.dataSelected.length > 0) {
        let ids = [];
        this.state.dataSelected.forEach(item => {
          ids.push({id: item.value});
        });
        params.coQuanQuanLys = ids;
      }
      this.setState({buttonLoading: true});
      if (this.state.addType == 2) {
        this.props.danhMuc.updateVaiTro({id: this.state.categoryId}, params).then(res => {
          this.getListData();
          this.closeDialog();
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        this.props.danhMuc.postVaiTro('',params).then(res => {
          this.getListData();
          this.closeDialog();
          Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleDelete(categoryId) {
    if(categoryId){
      this.setState({buttonLoading: true});
      this.props.danhMuc.deleteVaiTro({id: categoryId}).then(res => {
        this.getListData();
         Toastr(msg.delCategorySucess,'success');
         this.setState({buttonLoading: false});
      }).catch(error => {
            if (error.response) {
              Toastr(error.response.data.errors[0].detail,'error');
              this.setState({buttonLoading: false});
            }
        });
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleCheckBoxClick(e) {
    if (this.state.roleSelected.indexOf(e.target.value) > -1) {
      this.state.roleSelected.splice(this.state.roleSelected.indexOf(e.target.value),1);
      e.target.checked = false;
    } else {
      this.state.roleSelected.push(e.target.value);
      e.target.checked = true;
    }
    this.setState({
      dataRole: this.state.dataRole
    })
  }

  openDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory, isSubmit: false});
  }

  closeDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory, isSubmit: false});
    //
  }

  openAddNewCategory() {
    this.openDialog();
    this.setState({
      phoPhong: false,
      addType: 0,
      ten: '',
      moTa: '',
      LoaiVaiTro: '',
      roleSelected: [],
      dataSelected: [],
      isValid: true
    });
    this.getListVaiTro();
  }

  openUpdateCategory(item) {
    this.openDialog();
    let ids = [];
    if (item && item.listCoQuanQuanLy && item.listCoQuanQuanLy.length > 0) {
      item.listCoQuanQuanLy.forEach(item => {
        ids.push({value: item.coQuanQuanLyId, label: item.ten});
      });
    }
    this.setState({
      phoPhong: item.phoPhong,
      addType:2,
      ten: item.ten,
      moTa: item.moTa,
      categoryId: item.vaiTroId,
      LoaiVaiTro: item.loaiVaiTro,
      isValid: true,
      roleSelected: item.quyen ? item.quyen.split(',') : [],
      dataSelected: item.listCoQuanQuanLy ? ids : []
    });
  }

  handleCheckBox(e){
    this.setState({
      phoPhong: e.target.checked
    });
  }

  getListDV() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    DuLieuHeThong.actions.getCoQuanQuanLytheoDV.request().then(res => {
      if (res && res.data && res.data._embedded) {
        let dataDonVi = [...res.data._embedded.coQuanQuanLies];
        let DonVi = dataDonVi.filter(state => {
          return state.coQuanQuanLyId === userInfo.donViId;
        });
        this.setState({
          dataSelected: [
            {value: DonVi.length > 0 ? DonVi[0].coQuanQuanLyId : '', label: DonVi.length > 0 ? DonVi[0].ten : ''}
          ],
          dataOptions: res.data._embedded.coQuanQuanLies
        });
      }
    });
  }

  render() {

    let RoleItem = this.state.dataRole.map((item, i) => {
      let RoleName = item.tenQuyen.split(',');
      let RoleValue = item.giaTriQuyen.split(',');
      item.RoleDetail = [];
      RoleName.map((NameItem,j) => {
        let Data = {
          name: NameItem,
          value: RoleValue[j],
          status: false
        };
        item.RoleDetail.push(Data);
      });
      let SubRoleItems = item.RoleDetail.map((item,j) => {
        item.status = (this.state.roleSelected.indexOf(item.value) > -1) ? true : false;
        return(
            <li key={j}>
              <label className="pt-control pt-checkbox">
                <input type="checkbox" checked={item.status} value={item.value} onChange={this.handleCheckBoxClick.bind(this)}/>
                <span className="pt-control-indicator"></span>
                {item.name}
              </label>
            </li>
          )
      });
      return(
        <ul className="list-role-items" key={i}>
          <li className="role-name">
            <label className="role-title">{item.tenChucNang}</label>
            <ul className="sub-role-items">
              {SubRoleItems}
            </ul>
          </li>
        </ul>
      )
    });
  return (
    <MasterLayout routerName={this.props.route.name}>
      <div className="center reception-container">
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-reception"></i>Nhóm vai trò</p>
          </div>
          <div className="right-content">
            {
              CheckPermission('VAITRO_THEM') ?
                <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
              : null
            }
          </div>
        </div>
        <div className="bottom-content">
          <Search parents={this}/>
          <DataTable
            header = {header.categoryGroup.role}
            dataList={this.state.data}
            pageData={this.state.pageData}
            parent= {this}
            hideButtonExport
            tableLoading = {this.state.tableLoading}
          >
          <RowItemRole/>
          </DataTable>
        </div>
        <Dialog
          isOpen={this.state.popupAddCategory}
          onClose={this.closeDialog.bind(this)}
          title={this.state.addType == 2 ? 'Chỉnh sửa nhóm vai trò' : 'Thêm mới nhóm vai trò'}
          iconName="add-new"
          className="panel-popup category">
          <div className="pt-dialog-body">
            <Input className="col-6" label="Tên" value={this.state.ten} bindValidator={this} channel="formTaoDon" require
              onChange={this.onChange.bind(this, 'ten')}/>
            <DropDown className="col-6" label="Loại vai trò" bindValidator={this} channel="formTaoDon" require
              options={this.state.DataLoaiVaiTro} keyName="giaTri" valueName="ten" placeholder={{key: '', text: 'Chọn...'}}
              selectedValue={this.state.LoaiVaiTro} onChange={this.onChange.bind(this, 'LoaiVaiTro')}/>
            <ShowIf condition={this.state.LoaiVaiTro === "TRUONG_PHONG"}>
              <div className="col-25">
                <label className="ip-label">Phó phòng</label>
                <div className="items-form">
                  <div className="rows">
                    <div className="col-12">
                      <label className="pt-control pt-checkbox pt-large">
                        <input type="checkbox" id="isPP" className="pt-large" name="phoPhong" value={this.state.phoPhong} checked={this.state.phoPhong ? true : false} onChange={this.handleCheckBox.bind(this)}/>
                        <span className="tp-checkbox"></span>
                        <span className="name_checkbox"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </ShowIf>
            <DropDownTreeMultipleSelect className='tree-selected-nhomvaitro col-min-83' label="Đơn vị" dataOptions={this.state.dataOptions} dataSelected={this.state.dataSelected} onChange={this.onChange.bind(this, 'DonVi')} selectAllChildren={this.state.donViCon} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId' bindValidator={this} channel="formTaoDon" require/>
            <TextArea label="Mô tả" maxLength={99999} rows={5} value={this.state.moTa} onChange={this.onChange.bind(this, 'moTa')} className='col-12'/>
            <div className="col-12">
              <label className="pt-label">Phân quyền chức năng</label>
            </div>
            <div className="col-12">
              <div className="list-role-wrap">
                {RoleItem}
              </div>
            </div>
          </div>
          <div className="pt-dialog-footer">
              <Link onClick={this.closeDialog.bind(this)} className="btn-action btn-close" >
                <span>Đóng</span>
              </Link>
              <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)} >
                <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
              </Link>
          </div>
        </Dialog>
      </div>
    </MasterLayout>
    );
  }
}

Role.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: bindActionCreators(Danhmuc.actions, dispatch)
  };
}
export default connect(bindStateToProps, bindDispatchToProps)(Role);



// WEBPACK FOOTER //
// ./src/components/modules/category/Role.jsx